/**
 * Mobile WebView session utilities.
 * Writes to sessionStorage under the same keys that getToken() / getHospitalId()
 * already read from — so all existing RTK thunks work without modification.
 * In a React Native WebView, sessionStorage is sandboxed per WebView instance,
 * so there is no cross-contamination with a concurrent browser session.
 */

const parseJwt = (token: string): Record<string, any> | null => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return null;
  }
};

export const setMobileSession = (
  token: string,
  hospitalId: string,
  userId: string,
  role: string,
  name: string
): void => {
  sessionStorage.setItem('token', token);
  sessionStorage.setItem('hospitalId', hospitalId);
  sessionStorage.setItem('userId', userId);
  sessionStorage.setItem('role', role);
  sessionStorage.setItem('name', name);
};

export const clearMobileSession = (): void => {
  ['token', 'hospitalId', 'userId', 'role', 'name'].forEach(k =>
    sessionStorage.removeItem(k)
  );
};

export const isValidMobileSession = (): boolean => {
  const token = sessionStorage.getItem('token');
  if (!token) return false;
  const decoded = parseJwt(token);
  if (!decoded?.exp) return false;
  return decoded.exp * 1000 > Date.now();
};
